
import { defineComponent } from 'vue'

import OwnerBillingMixin from '~/mixins/ownerBillingMixin'
import SubscriptionMixin from '~/mixins/subscriptionMixin'
import { formatDate, parseISODate } from '~/utils/date'

export default defineComponent({
  name: 'CancelPlanModal',
  mixins: [SubscriptionMixin, OwnerBillingMixin],
  data() {
    return {
      updating: false,
      userEnteredOwner: ''
    }
  },

  computed: {
    paymentDate(): string | undefined {
      if (this.owner.billingInfo)
        return formatDate(parseISODate(this.owner.billingInfo.upcomingPaymentDate))
      return undefined
    }
  },

  methods: {
    async cancelPlan(close: () => void): Promise<void> {
      this.updating = true
      try {
        await this.cancelSubscriptionPlan({
          id: this.owner.id
        })
        this.$toast.success('Subscription successfully cancelled.')
      } catch (e) {
        this.$toast.danger('Something went wrong while cancelling your subscription.')
      } finally {
        this.$emit('refetch')
        await this.refetchData()
        this.updating = false
        close()
      }
    },

    async refetchData(): Promise<void> {
      const { owner, provider } = this.$route.params
      await this.fetchBillingDetails({
        login: owner,
        provider,
        refetch: true
      })
    }
  }
})
